const Vision = () => {
  return (
    <>
      <div
        className="text-white py-12 px-4 sm:px-6 relative bg-cover bg-no-repeat bg-center"
        style={{
          backgroundImage: "linear-gradient(270.95deg, rgba(19, 106, 133, 0.9) 0%, rgba(0, 163, 212, 0.9) 87.52%), url('/img/banner/vision_banner_img.png')",
        }}
      >
        {/* Orange floating circle */}
        <div className="hidden lg:block absolute bottom-[-64px] w-32 h-32 bg-orange-500 rounded-full z-0 float-animation" />

        <div className="relative z-10 max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-6 md:gap-10">
          {/* Heading */}
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold min-w-[100px] text-center md:text-left leading-snug">
            Vision
          </h2>

          {/* Content */}
          <div className="border-l-4 border-white pl-4 sm:pl-6 ml-2 sm:ml-4 md:ml-10 text-xs sm:text-sm md:text-base leading-relaxed max-w-3xl text-justify sm:text-left">
            <p className="font-semibold mb-3 sm:mb-4">
              At Intron Life Sciences, we envision a world where sustainable
              biotechnology transforms animal health and welfare.
            </p>
            <p className="text-justify">
              Through innovative microbial and probiotic solutions, we help
              producers raise healthier animals without harmful chemicals or
              antibiotics. Guided by science, integrity, and sustainability, we
              strive to enhance animal well-being, improve biosecurity, and
              protect the environment. Our goal is to become a global leader in
              animal health innovation—delivering lasting value to aquaculture,
              poultry, and livestock sectors while supporting a healthier
              planet.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Vision;
